import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPhone,
  faEnvelope,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faFacebook,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import "../styles/main.css";
import logo from "../assets/images/brand/logo.png";
import "../styles/footer.css";
import useBusinessHours from "../utils/useBusinessHours";

const Footer = () => {
  const hours = useBusinessHours();

  return (
    <footer className="footer-modern">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-column footer-brand">
            <img src={logo} alt="Cáceres Maquinarias" className="footer-logo" />
            <p className="footer-description">
              Desde 1977 brindando soluciones profesionales en maquinaria y
              herramientas. Concesionario oficial STIHL en Casilda, Santa Fe.
            </p>
          </div>

          <div className="footer-column">
            <h3 className="footer-column-title">Navegación</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Inicio</Link>
              </li>
              <li>
                <Link to="/productos">Productos</Link>
              </li>
              <li>
                <Link to="/videos">Aprendé</Link>
              </li>
              <li>
                <Link to="/nosotros">Nosotros</Link>
              </li>
              <li>
                <Link to="/contacto">Contacto</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-column-title">Contacto</h3>
            <ul className="footer-contact-list">
              <li>
                <FontAwesomeIcon icon={faLocationDot} className="footer-icon" />
                <span>
                  Blvd. Ovidio Lagos 2160
                  <br />
                  Casilda, Santa Fe
                </span>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="footer-icon" />
                <span>+549 3464 540919</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
                <span>caceresmaquinarias@gmail.com</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faClock} className="footer-icon" />
                {hours ? (
                  <span>
                    Lun-Vie: {hours.weekdays}
                    <br />
                    Sáb: {hours.saturday}
                  </span>
                ) : (
                  <span>Cargando horarios...</span>
                )}
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-column-title">Seguinos</h3>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/caceresmaq"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link facebook"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                href="https://www.instagram.com/caceresmaquinarias/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link instagram"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://wa.me/+5493464540919"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link whatsapp"
                aria-label="WhatsApp"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </div>
            <p className="footer-social-text">
              Conectate con nosotros en redes sociales para novedades y
              promociones
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            © {new Date().getFullYear()}{" "}
            <Link to="/login" className="footer-admin-link">
              Cáceres Maquinarias
            </Link>
            . Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
